import { render } from "./TravelAndTourManagementSystem.vue?vue&type=template&id=90038d02"
import script from "./TravelAndTourManagementSystem.vue?vue&type=script&lang=js"
export * from "./TravelAndTourManagementSystem.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__